<div id="searchBar">
    <form method="get"  class="search-form" fxLayout="row">
    <!--                        <button mat-raised-button [matMenuTriggerFor]="categoriesMenu" #categoriesMenuTrigger="matMenuTrigger" type="button" class="mat-elevation-z0 categories text-truncate text-muted">{{category?.name}}<mat-icon>arrow_drop_down</mat-icon></button>-->
    <!--                        <mat-menu #categoriesMenu="matMenu" [overlapTrigger]="false" xPosition="before" class="categories-dropdown">-->
    <!--                            <span (mouseleave)="categoriesMenuTrigger.closeMenu()">-->
    <!--                                <app-category-list [categories]="categories" [categoryParentId]="0" (change)="changeCategory($event)"></app-category-list>-->
    <!--                            </span>-->
    <!--                        </mat-menu>-->
        <input (focus)="openMenu()" (blur)="onBlur($event)" type="text" (keyup)="onChange($event)" (keyup)="search($event)" placeholder="הקלד לחיפוש..." fxFlex>

        <button mat-mini-fab (click)="search($event)" type="button" class="search-btn mat-elevation-z0 text-muted">
            <mat-icon>search</mat-icon>
        </button>

    </form>
    <div id="resultsWindows" *ngIf="menuOpen">
        <div fxLayout="row" class="header">
            <div fxLayout="column" class="w-100">פרקוד</div>
            <div fxLayout="column" class="w-100">שם מוצר</div>
            <div fxLayout="column" class="w-25">מחיר</div>
            <div fxLayout="column" class="w-25">תמונה</div>
        </div>
        <div fxLayout="row" class="body">
            <div fxLayout="column" class="w-100">

                <div *ngIf="resultList.length==0" fxLayout="row" >
                    <div fxLayout="column" class="w-100" fxLayoutAlign="center center">
                        <mat-spinner *ngIf="inProgress" diameter="30" strokeWidth="3"  color="primary"></mat-spinner>
                        <span *ngIf="!inProgress">לא נמצאו נתונים</span>
                    </div>
                </div>
                <div  fxLayout="row" style="cursor: pointer" *ngFor="let prd of resultList let i = index" class="row" [ngClass]="i%2==0?'even':'odd'" (click)="openProduct(prd)">
                    <div fxLayout="column" class="w-100">{{prd.barCode}}</div>
                    <div fxLayout="column" class="w-100">{{prd.name}}</div>
                    <div fxLayout="column" class="w-25">{{prd.client}}</div>
                    <div fxLayout="column" class="w-25"><img class="rowImage" [src]="prd.image" width="35" height="35"/></div>
                </div>
            </div>
        </div>
    </div>
</div>
